import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import { Client_Search } from "../../Configuration/API_URL";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  checkEmpty,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import DurationChangeComponent from "./DurationChangeComponent";
import ITRReportTable from "../../Components/ReportTables/ITRReportTable";
import refresh from "../../asset/images/refresh-new.svg";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function ITRReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [count, setCount] = useState();
  const [show, setShow] = useState(false);
  const [finalData, setFinalData] = useState([]);
  const [errorGrid, setErrorGrid] = useState(false);
  const [errorResp, setErrorResp] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [submitNameError, setSubmitNameError] = useState(false);
  const [page, setPage] = useState(1);
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [serverError, setServerError] = useState("");
  const [loader, setLoader] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [customShow, setCustomShow] = useState(false);
  const [selectDuration, setSelectDuration] = useState("");
  const [downloadLoader, setDownloadLoader] = useState(null)
  const [isSelected, setIsSelected] = useState(true);
  const clientInputRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  async function searchApiDetail(code, NoPage) {
    setScrollLoader(true);
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    console.log(payloadValue, "payload");


    const encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
        setClientList([])
      }
    } catch (error) {
    } finally {
      setScrollLoader(false);
    }
  }
  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setNameError(false);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const searchItrData = async () => {
    setLoader(true);
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
    };
    console.log(payloadValue, "encPayload");

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Update_Itr_Report,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        getItrTableData()
      }
      else {
        setErrorGrid(res?.message);
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);

    } finally {
      setLoader(false);
    }
  };

  const getItrTableData = async () => {
    setLoader(true);
    let payloadValue = {};

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Get_Itr_Report,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        
        setFinalData(res?.data);
        
        console.log(res?.data, "tableData");
      }
      else {
        setFinalData([]);
        setErrorGrid(res?.message);
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);

    } finally {
      setLoader(false);
      setCustomShow(false)
      setSelectDuration("")
    }
  };

  const downloadReport = async (pCode, id) => {
    setDownloadLoader(id);
    let payloadValue = {
      clientCode: pCode,
      id: id
    };
    console.log(payloadValue, "encPayload");

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Download_Itr_Report,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        window.open(res?.data, "_blank", "noopener,noreferrer");
        console.log(res?.data, "submitdata");
      }
      else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
    } finally {
      setDownloadLoader(null);
    }
  };

  const handleOnClick = (e) => {
    setShow(false);

    if (!clientCode) {
      setSubmitNameError("Please Select Client Name/Code");
      return;
    }

    if (!e.target.value) return;

    if (!selectDuration) {
      setErrorResp("Please Select Duration");
      return;
    }

    if (!compareDate(toDate)) {
      setErrorResp("Please Select To Date");
      return;
    }

    if (!compareDate(fromDate) || !compareDate(toDate) || !checkDateRange(fromDate, toDate)) {
      setErrorResp("Please Select Correct Date");
      return;
    }

    //if all good
    setErrorResp(false);
    setServerError(false);
    setSubmitNameError(false);
    searchItrData();
    setCustomShow(false)
    setSelectDuration("")
    setClientCode("");
    setFromDate("");
    setToDate("")
  };

  // const handleOnClick = (e) => {
  //   setShow(false);
  //   if (clientCode) {
  //     if (e.target.value) {
  //       if (selectDuration) {
  //         if (
  //           compareDate(fromDate) &&
  //           compareDate(toDate) &&
  //           checkDateRange(fromDate, toDate)
  //         ) {
  //           searchItrData();
  //           setErrorResp(false);
  //           // setShowDateName(true)
  //         } else {
  //           setErrorResp("Please Select Correct Date");
  //         }
  //       }
  //       else {
  //         setErrorResp("Please Select Duration");
  //       }
  //     }
  //   } else {
  //     setSubmitNameError("Please Select Client Name/Code");
  //   }
  // };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    setFinalData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    console.log(d, "datechange");

    // if (clientCode && toDate) {
    //   expirydatedropdown(clientCode, d, toDate);
    // }
    setFromDate(d);
    setErrorResp(false);
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    setFinalData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    // if (clientCode && fromDate) {
    //   expirydatedropdown(clientCode, fromDate, d);
    // }
    setErrorResp(false);
    setServerError(false);
  };

  useEffect(() => {
    getItrTableData()
  }, []);

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration = () => {
    setFinalData([]);
    setErrorResp("")
    // if (!clientCode) {
    //   setSubmitNameError("Please Select Client Name/Code");
    // }
  }

  const handleRefreshTable = () => {
    getItrTableData();
  }

  const handleDownloadBtn = (code, id) => {
    console.log(code, id, "download");
    downloadReport(code, id)
  }

  console.log(clientList, "clientList");


  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">ITR Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group" ref={dropdownRef}>
                <label className="form-label">Client Search:</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    ref={clientInputRef}
                    onChange={(e) => {
                      const { selectionStart, selectionEnd, value } = e.target;
                      let input = value
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, "")
                        e.target.value = input;
                        e.target.setSelectionRange(selectionStart, selectionEnd);

                      setClientCode(input);
                      setShow(true);
                      setErrorGrid(false);
                      setSubmitNameError(false);
                      setIsSelected(false);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pasteText = e.clipboardData.getData("text").toUpperCase();
                      const filtered = pasteText.replace(/[^A-Z0-9]/g, "");
                      setClientCode(filtered);
                      setShow(true);
                      setErrorGrid(false);
                      setSubmitNameError(false);
                      setIsSelected(false);
                    }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScroll(e)}
                      >
                        {clientList &&
                          clientList.map((item, i) => (
                            <li
                              key={i}
                              className="rm-maping-item-wrapper"
                              
                              onClick={() => {
                                setClientCode(item?.clientCode);
                                setShow(false);
                                setIsSelected(true);
                                console.log(item?.clientCode, "hsdfcgsc");
                              }}
                            >
                              <div> {item?.clientname}</div>
                              <div> {item?.clientCode}</div>

                            </li>
                          ))}
                        {scrollLoader && !loader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                        {nameError && !scrollLoader && (
                          <li
                            className="rm-maping-item-wrapper"
                            style={{
                              borderBottom: "none",
                              fontSize: "12px",
                            }}
                          >
                            {nameError}
                          </li>
                        )}
                      </ul>
                    </>
                  )}
                </div>
                {submitNameError && (
                  <span className="to-date-error" style={{ bottom: "-8px" }}>{submitNameError}</span>
                )}
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div>
            {customShow && <div className="col-md-3 col-sm-3 col-6 date-width">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}

            {customShow && <div className="col-md-3  col-sm-3 col-6 date-width">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={errorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />

            </div>}
          </div>
{console.log(clientCode, clientList, "clientList")
}
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
              disabled={loader || !isSelected }
            >
              {Constants.Search}
            </button>
          </div>

          <div className="for-grid-section pnl-wrapper itr-report">

            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : finalData && finalData.length > 0 ? (
              <>
                <div className="wrap-title-img">
                  <h2 className="report-title">Recent Report
                  </h2>
                  <img className="refresh-img" src={refresh} alt="refresh-img" onClick={handleRefreshTable} />
                </div>
                <div>
                  <ITRReportTable
                    finalData={finalData}
                    handleDownloadBtn={handleDownloadBtn}
                    downloadLoader={downloadLoader} />
                </div>
              </>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : (
              errorGrid && noDataFound(errorGrid)
            )}
          </div>
        </div>
      </main >
    </>
  );
}

export default ITRReportSidebar;
